import React, { useState, useEffect } from 'react';
import api from '../api';

const CAT = {
  information: { label:'Information', color:'var(--accent)' },
  maintenance: { label:'Maintenance', color:'var(--amber)' },
  warning:     { label:'Warning',     color:'var(--orange)' },
  critical:    { label:'Critical',    color:'var(--red)' },
};

// Compact announcements feed for dashboards / home. limit optional.
export default function AnnouncementsFeed({ limit }) {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState({});
  useEffect(() => { api.get('/announcements').then(r => setItems(r.data)).catch(()=>{}); }, []);
  if (!items.length) return null;
  const shown = limit ? items.slice(0, limit) : items;

  return (
    <div className="card" style={{ marginBottom:20 }}>
      <div style={{ fontSize:13, fontWeight:600, marginBottom:10 }}>📢 IT Announcements</div>
      {shown.map(a => {
        const c = CAT[a.category] || CAT.information;
        const isOpen = open[a.id];
        return (
          <div key={a.id} style={{ padding:'10px 0', borderTop:'1px solid var(--border)' }}>
            <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' }}>
              <span style={{ width:8, height:8, borderRadius:'50%', background:c.color, display:'inline-block' }} />
              <span style={{ fontSize:13, fontWeight:600 }}>{a.title}</span>
              {a.pinned && <span style={{ fontSize:11 }}>📌</span>}
              <span style={{ fontSize:10, color:c.color, border:`1px solid ${c.color}`, borderRadius:10, padding:'1px 8px' }}>{c.label}</span>
              <span style={{ fontSize:11, color:'var(--text3)', marginLeft:'auto' }}>{new Date(a.created_at).toLocaleDateString()}</span>
            </div>
            {a.description && (
              <div style={{ fontSize:12, color:'var(--text2)', marginTop:4 }}>
                {isOpen ? a.description : (a.description.length > 110 ? a.description.slice(0,110) + '… ' : a.description)}
                {a.description.length > 110 && <button onClick={() => setOpen(o => ({ ...o, [a.id]:!isOpen }))} style={{ background:'none', border:'none', color:'var(--accent)', cursor:'pointer', fontSize:12 }}>{isOpen ? 'Less' : 'Read More'}</button>}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
